import React, { Component, FormEvent, ChangeEvent } from 'react';
import {
    Button,
    Input,
    Form,
} from 'reactstrap';
import { withFirebase } from '../Firebase';

type AccountPasswordResetProps = {
    firebase: any;
};

type AccountPasswordResetState = {
    email: string;
    error: any | null;
    emailFocus: boolean;
    showSuccess?: boolean;
};

const INITIAL_STATE: AccountPasswordResetState = {
    email: '',
    error: null,
    emailFocus: false,
};

class AccountPasswordResetForm extends Component<
    AccountPasswordResetProps,
    AccountPasswordResetState
> {
    constructor(props: AccountPasswordResetProps) {
        super(props);
        this.state = { ...INITIAL_STATE, showSuccess: false };
    }

    onSubmit = (event: FormEvent<HTMLFormElement>) => {
        const { email } = this.state;
        this.props.firebase
            .doPasswordReset(email)
            .then(() => {
                this.setState({ ...INITIAL_STATE, showSuccess: true });
                setTimeout(() => {
                    this.setState({ showSuccess: false });
                }, 3000);
            })
            .catch((error: Error) => {
                this.setState({ error });
            });
        event.preventDefault();
    };

    onChange = (event: ChangeEvent<HTMLInputElement>) => {
        this.setState({ [event.target.name]: event.target.value } as any);
    };

    render() {
        const { email, error, showSuccess } = this.state;
        const isInvalid = email === '';

        return (
            <div className="mb-4">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6 className="mb-0 font-weight-bold">Reset My Password</h6>
                    <Button
                        className="btn-info-custom btn-sm"
                        disabled={isInvalid}
                        type="submit"
                        form="password-reset-form"
                    >
                        <span>Reset</span>
                    </Button>
                </div>
                {showSuccess && (
                    <div className="alert alert-success text-center mb-3" role="alert">
                        Email sent! Please check your inbox.
                    </div>
                )}
                <Form onSubmit={this.onSubmit} id="password-reset-form">
                    <Input
                        name="email"
                        value={this.state.email}
                        onChange={this.onChange}
                        type="text"
                        placeholder="Email Address"
                        onFocus={() => this.setState({ emailFocus: true })}
                        onBlur={() => this.setState({ emailFocus: false })}
                    />
                    {error && <p className="text-danger small">{error.message}</p>}
                </Form>
            </div>
        );
    }
}

export default withFirebase(AccountPasswordResetForm);